'use client'

import * as React from 'react'

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label: string
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, id, ...props }, ref) => {
    const reactId = React.useId()
    const fieldId = id ?? `textarea-${reactId}`
    return (
      <>
        <label htmlFor={fieldId}>{label}</label>
        <textarea ref={ref} id={fieldId} {...props} />
      </>
    )
  }
)

Textarea.displayName = 'Textarea'
